import isomorphicRoute from '@client/helperComponents/isomorphicRoute';
import ErrorLoadingRouteChunk from '@client/containers/errorLoadingRouteChunk/ErrorLoadingRouteChunk';
import Loader from '@client/components/loader/Loader';
import { withRestrictions } from '@client/helperComponents/restrict/withRestrictions';
import { removeRestrictedRoutes } from '@client/helperComponents/restrict/restrictUtils';

const options = {
  error: ErrorLoadingRouteChunk,
  loading: Loader,
};

export function getProfileRoutes(userRestrictions) {
  let routes = {
    ACCOUNT: {
      TO: '/mitt-konto',
      LABEL: 'Mitt Konto',
      RESTRICTIONS: {
        shouldBeLoggedIn: true,
      },
      ROUTES: {
        PROFILE: {
          TO: '/mitt-konto/profil',
          LABEL: 'Profil',
          RESTRICTIONS: {
            shouldBeLoggedIn: true,
          },
          ROUTES: {
            INFORMATION: {
              TO: '/mitt-konto/profil/mina-uppgifter',
              LABEL: 'Mina uppgifter',
              RESTRICTIONS: {
                shouldBeLoggedIn: true,
                permissions: ['EMAIL'],
              },
            },
            PASSWORD: {
              TO: '/mitt-konto/profil/andra-losenord',
              LABEL: 'Ändra lösenord',
              RESTRICTIONS: {
                shouldBeLoggedIn: true,
                permissions: ['EMAIL'],
              },
            },
          },
        },
        FUNDRAISERS: {
          TO: '/mitt-konto/mina-insamlingar',
          LABEL: 'Mina insamlingar',
          RESTRICTIONS: {
            shouldBeLoggedIn: true,
          },
        },
        /*DONATIONS: {
          TO: '/mitt-konto/mina-donationer',
          LABEL: 'Mina Gåvor',
          RESTRICTIONS: {
            shouldBeLoggedIn: true,
          },
        },*/
        HELP: {
          TO: '/hjalp',
          LABEL: 'Frågor och svar',
          RESTRICTIONS: {
            shouldBeLoggedIn: true,
          },
        },
      },
    },
  };

  if (!userRestrictions) {
    return routes;
  } else {
    return removeRestrictedRoutes(routes, userRestrictions);
  }
}

const PROFILE_ROUTES = getProfileRoutes();

export const routesProfile = {
  path: `${PROFILE_ROUTES.ACCOUNT.TO}/*`,
  componentPath: 'pages/profilePage/ProfilePage',
  Component: isomorphicRoute(
    () => import('pages/profilePage/ProfilePage'),
    options
  ),
  routes: [
    {
      path: PROFILE_ROUTES.ACCOUNT.ROUTES.PROFILE.ROUTES.INFORMATION.TO.replace(
        `${PROFILE_ROUTES.ACCOUNT.TO}/`,
        ''
      ),
      exact: true,
      componentPath:
        'pages/profilePage/accountInformationRoute/AccountInformationRoute',
      Component: withRestrictions(
        PROFILE_ROUTES.ACCOUNT.ROUTES.PROFILE.ROUTES.INFORMATION.RESTRICTIONS
      )(
        isomorphicRoute(
          () =>
            import(
              'pages/profilePage/accountInformationRoute/AccountInformationRoute'
            ),
          options
        ),
        isomorphicRoute(() => import('pages/homePage/HomePage'), options)
      ),
    },
    {
      path: PROFILE_ROUTES.ACCOUNT.ROUTES.PROFILE.ROUTES.PASSWORD.TO.replace(
        `${PROFILE_ROUTES.ACCOUNT.TO}/`,
        ''
      ),
      exact: true,
      componentPath:
        'pages/profilePage/changePasswordRoute/ChangePasswordRoute',
      Component: withRestrictions(
        PROFILE_ROUTES.ACCOUNT.ROUTES.PROFILE.ROUTES.INFORMATION.RESTRICTIONS
      )(
        isomorphicRoute(
          () =>
            import('pages/profilePage/changePasswordRoute/ChangePasswordRoute'),
          options
        ),
        isomorphicRoute(() => import('pages/homePage/HomePage'), options)
      ),
    },
    {
      path: PROFILE_ROUTES.ACCOUNT.ROUTES.FUNDRAISERS.TO.replace(
        `${PROFILE_ROUTES.ACCOUNT.TO}/`,
        ''
      ),
      exact: true,
      componentPath: 'pages/profilePage/myFundraisersRoute/MyFundraisersRoute',
      Component: withRestrictions(
        PROFILE_ROUTES.ACCOUNT.ROUTES.FUNDRAISERS.RESTRICTIONS
      )(
        isomorphicRoute(
          () =>
            import('pages/profilePage/myFundraisersRoute/MyFundraisersRoute'),
          options
        ),
        isomorphicRoute(() => import('pages/homePage/HomePage'), options)
      ),
    },
    /*{
      path: PROFILE_ROUTES.ACCOUNT.ROUTES.DONATIONS.TO,
      exact: true,
      componentPath: 'pages/profilePage/myDonationsRoute/MyDonationsRoute',
      Component: withRestrictions(
        PROFILE_ROUTES.ACCOUNT.ROUTES.DONATIONS.RESTRICTIONS
      )(
        universal(
          import('pages/profilePage/myDonationsRoute/MyDonationsRoute'),
          options
        ),
        universal(import('pages/homePage/HomePage'), options)
      ),
    },*/
  ],
};
